"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const string_utils_1 = require("@/common/string_utils");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ isSettlementDisabled, isRequesting, request_amount, onSettlementRequestSubmit, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            padding: '50px 16px 20px',
            '@media (max-width: 768px)': { backgroundColor: 'var(--surface-bg) !important' },
        } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                width: '100%',
                height: '56px',
                padding: '0 8px',
                borderRadius: '12px',
                lineHeight: '26px',
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'var(--white)',
                bgcolor: 'var(--primary-main)',
                ':hover': {
                    bgcolor: 'var(--primary-main)',
                },
                '&.Mui-disabled': {
                    color: 'var(--gray-30)',
                    bgcolor: 'var(--surface-bg)',
                },
            }, disabled: isSettlementDisabled, onClick: onSettlementRequestSubmit }, { children: isRequesting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "info", thickness: 8 })) : request_amount ? ((0, jsx_runtime_1.jsx)("span", { children: `${(0, string_utils_1.money)(request_amount)} ${t('정산 접수')}` })) : ((0, jsx_runtime_1.jsx)("span", { children: t('정산 접수') })) })) })));
}
exports.default = default_1;
